import { createContext, useState } from 'react';
import moment from 'moment';

import { API_BASE_URL } from '../../config/baseURLs';
import axiosInstance from '../../api/axiosInstance';

const RfqQueueContext = createContext();

export const RfqQueueProvider = ({ children }) => {
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const [view, setView] = useState('open-queue');

	const SINGAPORE_TZ = 'Asia/Singapore';

	const preprocessData = (data, dateFields) => {
		return data.map((row) => {
			const newRow = { ...row };
			dateFields.forEach((field) => {
				if (row.TASK_STATUS === 'Completed' || row.TASK_STATUS === 'Dropped') {
					newRow[`${field}_label`] = null;
					return;
				}

				if (row[field]) {
					const dateValue = moment.tz(row[field], SINGAPORE_TZ).startOf('day');
					const today = moment.tz(SINGAPORE_TZ).startOf('day');
					const openDay = today.diff(dateValue, 'days');

					newRow[`${field}_label`] = openDay;
				} else {
					newRow[`${field}_label`] = null;
				}
			});
			return newRow;
		});
	};

	const getData = () => {
		setIsLoading(true);
		axiosInstance
			.get(`${API_BASE_URL}/rfq-queue?view=${view}`)
			.then((response) => {
				const responseData = response.data?.data || [];
				setData(preprocessData(responseData, ['CREATED_AT']));
				setError(null);
			})
			.catch((err) => {
				setError(err);
				setData(null);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return (
		<RfqQueueContext.Provider
			value={{
				getData,
				data,
				setData,
				isLoading,
				error,
				view,
				setView,
			}}
		>
			{children}
		</RfqQueueContext.Provider>
	);
};

export default RfqQueueContext;
